import React from 'react';
import { emitter } from '../../services';

export const AlertPopupQueueContext = React.createContext({
  emitter: emitter,
});
